import { createFileRoute, Link } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAccess } from "@/hooks/use-access";
import { CheckCircle2 } from "lucide-react";

export const Route = createFileRoute("/checkout/return")({
  head: () => ({ meta: [{ title: "Welcome to Boardroom" }] }),
  validateSearch: (s: Record<string, unknown>): { session_id?: string } => ({
    session_id: typeof s.session_id === "string" ? s.session_id : undefined,
  }),
  component: CheckoutReturn,
});

function CheckoutReturn() {
  const { session_id } = Route.useSearch();
  const access = useAccess();

  useEffect(() => {
    // Poll refresh a few times; the webhook may take a beat to land.
    const id = setInterval(() => access.refresh(), 1500);
    return () => clearInterval(id);
  }, [access]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-foreground px-6">
      <div className="max-w-md w-full boardroom-card p-10 text-center space-y-5">
        <CheckCircle2 className="h-12 w-12 text-[color:var(--gold)] mx-auto" />
        <h1 className="font-display text-2xl font-semibold">You're in.</h1>
        <p className="text-sm text-muted-foreground">
          {access.hasAccess
            ? "Your membership is active. Welcome to the Boardroom."
            : "Setting up your account… this usually takes a few seconds."}
        </p>
        <Link
          to="/dashboard"
          reloadDocument
          className="inline-block bg-[color:var(--gold)] text-black font-medium px-6 py-2.5 rounded-md hover:opacity-90 transition"
        >
          Enter the Boardroom →
        </Link>
        {session_id && (
          <p className="text-xs text-muted-foreground opacity-60">
            Session {session_id.slice(0, 20)}…
          </p>
        )}
      </div>
    </div>
  );
}
